import {MappingInputs} from '../../globalData/MappingInputs';
import {addMappings, Mapping, MappingType} from '../../../redux/slices/MappingSlice';
import {assignMappingGlobal, getMappingContent, Parcel, setMappings} from '../../functions/GlobalData';
import React, {useEffect, useState} from 'react';
import CustomDialog from '../../global/CustomDialog';
import {useTranslation} from 'react-i18next';
import {useAppDispatch} from '../../../redux/hooks';
import {OverlayAddMapping} from '../../globalData/OverlayAddMapping';
import {showMessageOnError} from '../../global/CustomToast';

type Props = {
    projectId: string,
    selectedValue: any,
    showMappingAdd: boolean,
    mappingId: string,
    mappingType: MappingType,
    activeMappings: any[],
    setValues: (prevState: any) => void,
    onChange: () => void,
    onHide: () => void,
}

export const LandRegisterPersonOrParcelMapping = (props: Props) => {

    const {t} = useTranslation(['common', 'globalData', 'toasts']);

    const dispatch = useAppDispatch();

    const [showMappingAdd, setShowMappingAdd] = useState<boolean>(props.showMappingAdd);
    const [showMappingEdit, setShowMappingEdit] = useState<boolean>(false);
    const [selectedValue, setSelectedValue] = useState<Parcel | undefined>(props.selectedValue);
    const [mappingInputs, setMappingInputs] = useState<any>({});
    const [mappingDialog, setMappingDialog] = useState<any>(undefined);
    const [hasValidationError, setHasValidationError] = useState<boolean>(false);
    const [idTypeName, setIdTypeName] = useState<string>('');
    const [fieldName, setFieldName] = useState<string>('');


    useEffect(() => {
        switch (props.mappingType) {
            case MappingType.personLandRegister:
                setIdTypeName('person_id');
                setFieldName('person');
                break;

            case MappingType.landRegisterParcel:
                setIdTypeName('flurstueck_id');
                setFieldName('parcel');
                break;
        }
    }, [props.mappingType]);

    useEffect(() => {
        setShowMappingAdd(props.showMappingAdd);
    }, [props.showMappingAdd]);

    useEffect(() => {
        setSelectedValue(props.selectedValue);
    }, [props.selectedValue]);


    useEffect(() => {
        if (selectedValue && props.mappingType != null) {
            setShowMappingEdit(true);
            setMappingDialog(getMappingContent(props.projectId, selectedValue, idTypeName, props.mappingId, props.mappingType, setMappingInputs, setHasValidationError));
        }
    }, [selectedValue]);

    const onAddMapping = (selectedItem: any, mapping: Mapping) => {
        const personType = mapping.person_type_id;
        const anteil = mapping.anteileigentuemer;
        const mitanteil = mapping.miteigentumsanteil;
        const recht = mapping.artrechtsgemeinschaft;
        const bvnr = mapping.bvnr;
        const gr_ha = mapping.gr_ha;
        const gr_a = mapping.gr_a;
        const gr_m2 = mapping.gr_m2;
        const lfdnr_eintragung = mapping.lfdnr_eintragung;
        const lfdnr_bestandsverzeichnis = mapping.lfdnr_bestandsverzeichnis;
        const grundlage_eintragung = mapping.grundlage_eintragung;
        const ehepartner = mapping.ehepartner;

        let sI = {...selectedItem};

        sI.person_type_id = personType;
        sI.anteileigentuemer = anteil;
        sI.miteigentumsanteil = mitanteil;
        sI.artrechtsgemeinschaft = recht;

        sI.bvnr = bvnr;
        sI.gr_ha = gr_ha;
        sI.gr_a = gr_a;
        sI.gr_m2 = gr_m2;

        sI.lfdnr_eintragung = lfdnr_eintragung;
        sI.lfdnr_bestandsverzeichnis = lfdnr_bestandsverzeichnis;
        sI.grundlage_eintragung = grundlage_eintragung;
        sI.ehepartner = ehepartner;

        let temp: Mapping = {
            id: sI[idTypeName],
            mapping_type: props.mappingType,
            project_id: props.projectId,
            common_data: true,
            person_type_id: personType,
            anteileigentuemer: anteil,
            miteigentumsanteil: mitanteil,
            artrechtsgemeinschaft: recht,
            bvnr: bvnr,
            gr_ha: gr_ha,
            gr_a: gr_a,
            gr_m2: gr_m2,
            lfdnr_eintragung: lfdnr_eintragung,
            lfdnr_bestandsverzeichnis: lfdnr_bestandsverzeichnis,
            grundlage_eintragung: grundlage_eintragung,
            ehepartner: ehepartner,
        };

        switch (props.mappingType) {
            case MappingType.personLandRegister:
                temp.person_id = props.mappingId;
                break;

            case MappingType.landRegisterParcel:
                temp.grundbuch_id = props.mappingId;
                break;
        }

        dispatch(addMappings(temp));

        props.setValues((prevState: any) => {
            let temp = [...prevState];

            if (temp) {
                if (temp.indexOf(sI) < 0) {
                    temp.push(sI);
                }
            }
            return temp;
        });

        hideDialog();

        props.onChange();
    };

    const assignMapping = () => {
        if (hasValidationError) {
            showMessageOnError(t('error'), t('checkYourInputs'));
        } else {
            assignMappingGlobal('flurstueck_id', selectedValue, mappingInputs, props.mappingType, dispatch, props.setValues);
            props.onChange();
            hideDialog();
        }
    };

    const hideDialog = () => {
        setShowMappingAdd(false);
        setShowMappingEdit(false);
        setSelectedValue(undefined);
        setMappingInputs({});
        props.onHide();
    };

    return (<>
        {showMappingAdd &&
            <CustomDialog
                className={'mapping-dialog'}
                header={t('globalData:global.mapping.header')}
                onCancel={hideDialog}
                visible={showMappingAdd}
                maximized={false}>
                <OverlayAddMapping id={props.mappingId}
                                   projectId={props.projectId}
                                   id_type={fieldName}
                                   type={props.mappingType}
                                   activeMappings={props.activeMappings}
                                   onSubmit={onAddMapping}/>
            </CustomDialog>}

        {showMappingEdit && <CustomDialog
            className={'mapping-dialog'}
            header={t('globalData:global.mapping.header')}
            onCancel={hideDialog}
            visible={showMappingEdit}
            maximized={false}
            onClick={assignMapping}>
            {mappingDialog}
        </CustomDialog>}</>);
};
